var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlGolfViewOutlined = function SvgHtlGolfViewOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 11.5a2.326 2.326 0 0 1 1.537-1.985.499.499 0 0 1 .688.618.5.5 0 0 1-.256.285c-.607.29-.969.695-.969 1.083C3 12.21 4.232 13 6 13s3-.79 3-1.5a1.18 1.18 0 0 0-.387-.826A2.707 2.707 0 0 0 7 10v1.5a.5.5 0 0 1-1 0V2.44a.49.49 0 0 1 .023-.1l.005-.014.006-.013V2.29a.5.5 0 0 1 .15-.182l.007-.005a.5.5 0 0 1 .534-.031l.013.008H6.751l3 2a.5.5 0 0 1 0 .832l-2.778 1.85V9a3.7 3.7 0 0 1 2.313.96 2.166 2.166 0 0 1 .687 1.54c0 1.4-1.757 2.5-4 2.5C3.73 14 2 12.9 2 11.5Zm5-5.935 1.6-1.066L7 3.433v2.132Zm4 3.934a1.5 1.5 0 1 1 3-.002 1.5 1.5 0 0 1-3 .003v-.001Zm1 0a.5.5 0 1 0 .038-.19.502.502 0 0 0-.038.19Z"
  })));
};
export default SvgHtlGolfViewOutlined;